import { all, call, put } from "redux-saga/effects";

import {
  fetchDcResearchData,
  fetchDcResearchDataSuccess,
  fetchDcResearchDataError,
} from "../modules/dcResearch";
import { getDCResearchData } from "../end-points/dcResearch";
import { transformFilterOptions } from "../../utils/formatFilterOptions";
import { ISuccessResponse } from "../../types/response.types";
import { DCResearchCards } from "../../types/cards.types";

interface IDCResearchData {
  getUnifiedDcResearchValues: Partial<DCResearchCards>;
}

export function* getDcResearchDataSaga(
  action: ReturnType<typeof fetchDcResearchData>
) {
  const { filters, fields } = action.value;
  try {
    const response: ISuccessResponse<IDCResearchData>[] = yield all(
      fields.map((field) =>
        call(getDCResearchData, field, transformFilterOptions(filters))
      )
    );
    let dcResearchValues: Partial<DCResearchCards> = {};
    response.forEach((res) => {
      dcResearchValues = {
        ...dcResearchValues,
        ...res.data.getUnifiedDcResearchValues,
      };
    });
    yield put(fetchDcResearchDataSuccess(dcResearchValues));
  } catch (error: any) {
    console.log("getDcResearchDataSaga Error:", error);
    yield put(fetchDcResearchDataError());
  }
}
